// Legacy links contain "ID|Name&" entries; the advanced drawer stores comma-separated IDs.
export const parseInvoiceGroupIds = (value: string | null): string[] => {
  if (!value) {
    return [];
  }

  const ids = value.includes('|')
    ? value
        .split('&')
        .filter((entry) => entry.includes('|'))
        .map((entry) => entry.slice(0, entry.indexOf('|')))
    : value.split(',');

  return [...new Set(ids.map((id) => id.trim()).filter(Boolean))];
};
